import withPropsOnChange from 'recompose/withPropsOnChange';
import { connect } from 'react-redux';
import withHandlers from 'recompose/withHandlers';
import lifecycle from 'recompose/lifecycle';
import compose from 'recompose/compose';

import { getActiveShop, isBarberUser } from '../../../auth/selectors';
import { canUserViewWaitingList } from '../../../common/helpers/users';
import withPermissions from '../../../auth/utils/withPermissions';
import { shopFetchWaitingListCustomers } from '../waitingListCustomers/actions';
import { getCustomersWaiting } from '../waitingListCustomers/selectors';
import { getDate } from '../../appointments/appointmentSelector';
import WaitingListsSelector from '../components/WaitingListLink';
import { flagNames, withInjectFeatureFlagsToProps } from '../../../../modules/infra/feature-flags';
import withToggle from '../../../common/hoc/withToggle';

const WaitingListsSelectorContainer = compose(
  withInjectFeatureFlagsToProps([flagNames.WALK_IN_LIST]),
  withPermissions,
  withToggle('walkInListOpen', false),
  connect((state, ownProps) => {
    const date = getDate(state);
    const isBarber = isBarberUser(state);
    const shop = getActiveShop(state);

    return {
      customersWaiting: getCustomersWaiting(state, date),
      shop,
      isBarberUser: isBarber,
      date,
      canSeeWaitingList: !isBarber && shop?.waitingListEnabled && canUserViewWaitingList(ownProps.permissions),
      canSeeWalkInList: ownProps[flagNames.WALK_IN_LIST] && !isBarber && shop?.settings.walkInListEnabled,
    };
  }, { shopFetchWaitingListCustomers }),
  withHandlers({
    fetch: props => () => {
      if (props.canSeeWaitingList) {
        props.shopFetchWaitingListCustomers(props.shop.id, props.date);
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.fetch();
    },
  }),
  withPropsOnChange(
    ['date'],
    (props) => {
      props.fetch();
    }
  ),
)(WaitingListsSelector);

export default WaitingListsSelectorContainer;
